// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productPromoContainer":"_1qfjp","brandLogoImage":"-XvT-","promoImage":"hm-oK"};